export function CorrectIcon(props) {
    const { color="currentColor" } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 30 30"
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m22 11-8 8-4-4"
            ></path>
        </svg>
    )
}

export function WrongIcon(props) {
    const { color="currentColor" } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            viewBox="0 0 30 30"
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m19 11-8 8M11 11l8 8"
            ></path>
        </svg>
    )
}